var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import URI from 'urijs';
import { HITLBase } from './HITLBase';
export class Agents extends HITLBase {
    static getAgents(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = this.getBaseUrl(options);
            const params = _.omit(options, ['version']);
            return this.request({
                route,
                params,
            });
        });
    }
    static getCompleteAgents(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(this.AGENTS_COMPLETE).href();
            const params = _.pick(options, ['accountId']);
            return this.request({
                route,
                params,
            });
        });
    }
    static getCompleteAgentById(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl)
                .segment(this.AGENTS_COMPLETE)
                .segment(options.agentId)
                .href();
            const params = _.pick(options, ['accountId', 'multiUserId']);
            return this.request({
                route,
                params,
            });
        });
    }
    static searchAgents(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(this.AGENT_SEARCH_URL).href();
            const data = _.omit(options, ['version']);
            return this.request({
                method: 'POST',
                route,
                data,
            });
        });
    }
    static updateAgent(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = this.getBaseUrl(options);
            const params = _.pick(options, ['agentId']);
            const data = _.omit(options, ['version', 'agentId']);
            return this.request({
                method: 'PUT',
                route,
                params,
                data,
            });
        });
    }
    static updateAgentRuleGroups(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(this.AGENT_RULE_GROUPS_URL).href();
            const params = _.pick(options, ['agentId']);
            const data = _.omit(options, ['version', 'agentId']);
            return this.request({
                method: 'PUT',
                route,
                params,
                data,
            });
        });
    }
    static getAgentStatus(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const version = _.get(options, ['version']);
            const baseUrl = this.getBaseUrl(options);
            const route = (version === 2)
                ? new URI(baseUrl).segment(this.AGENT_STATUS_URL).href()
                : new URI(baseUrl).segment(this.GET_AGENT_STATUS_URL).href();
            const params = _.pick(options, ['agentId']);
            return this.request({
                route,
                params,
            });
        });
    }
    static pingAgentStatus(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(this.PING_AGENT_STATUS_URL).href();
            const params = _.pick(options, ['agentId']);
            return this.request({
                route,
                method: 'PUT',
                params,
            });
        });
    }
    static setAgentStatus(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(this.AGENT_STATUS_URL).href();
            const params = _.pick(options, ['agentId']);
            const data = _.omit(options, ['version', 'agentId']);
            return this.request({
                method: 'PUT',
                route,
                params,
                data,
            });
        });
    }
    static updateAgentsStatusByQuery(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl)
                .segment(this.UPDATE_AGENTS_STATUS_BY_QUERY_URL)
                .href();
            const data = _.omit(options, ['version', 'maxRetries']);
            const maxRetries = _.get(options, ['maxRetries'], 3);
            let result;
            let attempts = 0;
            while (_.isUndefined(result) && attempts < maxRetries) {
                attempts++;
                try {
                    result = yield this.request({
                        method: 'PUT',
                        route,
                        data,
                    });
                }
                catch (e) {
                    if (e.message !== 'could not serialize access due to concurrent update')
                        throw e;
                }
            }
            return result;
        });
    }
}
Agents.MODULE_URL = 'agents';
Agents.AGENT_SEARCH_URL = 'search';
Agents.AGENTS_COMPLETE = 'complete';
Agents.GET_AGENT_STATUS_URL = 'agent-status';
Agents.AGENT_RULE_GROUPS_URL = 'rule-groups';
Agents.PING_AGENT_STATUS_URL = 'ping-agent-status';
Agents.AGENT_STATUS_URL = 'status';
Agents.UPDATE_AGENTS_STATUS_BY_QUERY_URL = 'status/query';
//# sourceMappingURL=Agents.js.map